import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import {number_format,number_input_format} from '../helper/format';
import $ from 'jquery';
import {
  isMobile
} from "react-device-detect";

export default class Insurepopup extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            open: false,
            insures: []
        }
    }
    Open()
    {
        this.setState({
            open: true
        }, this.requestData);
    }
    Close()
    {
        this.setState({
            open: false
        });
    }
    requestData()
    {
        const self = this;
        $.post('https://api.tfamily.co.kr/api/mobile/base',
        {},
        function(data){
            const parsedData = JSON.parse(data);
            let items = parsedData.data.insurance;
            self.setState({
                insures: items
            });

        });
    }
    Apply(item)
    {
        this.props.onInsureChanged(item)
        this.Close();
    }
    render()
    {
        const self = this;
        return (
            <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
                <div className="modal-dialog modal-lg mb0">
                    <div className={ (isMobile) ? 'popupPadding3' : 'popupPadding pr45'}>
                    <div className="md-popup-header"> &nbsp;휴대폰보험</div>
                        <div className="row pl15 pr15">
                            <table className="table guideTable mb0">
                                <tbody>
                                    <tr>
                                        <td className="width180">보험명</td>
                                        {(isMobile) ? null : <td>상세설명</td> }
                                        <td className="width180">월 보험료</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="scroll400">
                            <table className="table priceTable">
                                <tbody>
                                    <tr key={0} onClick={()=>{self.Apply()}}>
                                        <td className="width180 text-center"><b>미적용</b></td>
                                        {(isMobile) ? null : <td></td> }
                                        <td className="width180"></td>
                                    </tr>
                                    {self.state.insures.map((item, index)=>{
                                        return (
                                            <tr key={index} onClick={()=>{self.Apply(item)}}>
                                                <td>{item.name}</td>
                                                {(isMobile) ? null :<td>
                                                    대상 단말기 : {item.device} <br/>
                                                    보상 한도 : {item.max_compensation} <br/>
                                                    자기 부담금 : {item.deductible}
                                                </td>}
                                                <td className="text-center">
                                                    {number_input_format(item.price)} 원
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}
